import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEuroSign,
  faFileSignature,
  faUser,
  faChartLine,
  faBook,
  faHome,
  faFunnelDollar,
  faChartBar,
} from '@fortawesome/free-solid-svg-icons';

import homeIcon from '../../Icons/home.svg';
import previousIcon from '../../Icons/previous.svg';
import euroIcon from '../../Icons/euro.svg';
import userIcon from '../../Icons/user.svg';
import contractIcon from '../../Icons/contract.svg';
import analysisIcon from '../../Icons/analysis.svg';
import statisticsIcon from '../../Icons/statistics.svg';
import booksIcon from '../../Icons/books.svg';
import bookIcon from '../../Icons/book.svg';

import './CustomMenuIcon.scss';

const CoogSvg = ({ path, alt }) => <img src={path} alt={alt} className="custom-menu-icon" />;
CoogSvg.propTypes = {
  path: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export const CustomMenuIcon = ({ name, alt }) => {
  switch (name) {
    case 'home':
      return <CoogSvg path={homeIcon} alt={alt} />;

    case 'previous':
      return <CoogSvg path={previousIcon} alt={alt} />;

    case 'euro':
      return <CoogSvg path={euroIcon} alt={alt} />;

    case 'party':
      return <CoogSvg path={userIcon} alt={alt} />;

    case 'contracts':
      return <CoogSvg path={contractIcon} alt={alt} />;

    case 'analysis':
      return <CoogSvg path={analysisIcon} alt={alt} />;

    case 'statistics':
      return <CoogSvg path={statisticsIcon} alt={alt} />;

    case 'books':
      return <CoogSvg path={booksIcon} alt={alt} />;

    case 'book':
      return <CoogSvg path={bookIcon} alt={alt} />;
    // FA
    case 'fa-quotations':
      return <FontAwesomeIcon icon={faEuroSign} size="lg" fixedWidth />;

    case 'fa-book':
      return <FontAwesomeIcon icon={faBook} size="lg" fixedWidth />;

    case 'fa-user':
      return <FontAwesomeIcon icon={faUser} size="lg" fixedWidth />;

    case 'fa-chart-line':
      return <FontAwesomeIcon icon={faChartLine} size="lg" fixedWidth />;

    case 'fa-contract':
      return <FontAwesomeIcon icon={faFileSignature} size="lg" fixedWidth />;

    case 'fa-home':
    case 'dashboard':
      return <FontAwesomeIcon icon={faHome} size="lg" fixedWidth />;

    case 'fa-funnel-dollar':
      return <FontAwesomeIcon icon={faFunnelDollar} size="lg" fixedWidth />;

    case 'fa-chart-bar':
      return <FontAwesomeIcon icon={faChartBar} size="lg" fixedWidth />;

    default:
      return <CoogSvg path={homeIcon} alt={alt} />;
  }
};
CustomMenuIcon.propTypes = {
  name: PropTypes.oneOf([
    'home',
    'previous',
    'euro',
    'user',
    'contract',
    'analysis',
    'statistics',
    'books',
    'book',
    'dashboard',
    'fa-quotations',
    'fa-chart-line',
    'fa-contract',
    'fa-user',
    'fa-book',
    'fa-funnel-dollar',
    'fa-chart-bar',
  ]).isRequired,
  alt: PropTypes.string.isRequired,
};

export default CustomMenuIcon;
